export const pid_item = [
  {
    pid_item_nombre: "Programa Institucional de Desarrollo 2023-2028",
    pid_item_url: "/contenido/informacion/publicaciones/1. PID_SSH_2023-2028.pdf",
    pid_item_titulo: ""
  },
  {
    pid_item_nombre: "PID de los Servicios de Salud de Hidalgo 2017-2022",
    pid_item_url: "/contenido/informacion/publicaciones/2. PID_ SSH_2017-2022.pdf",
    pid_item_titulo: ""
  },
  {
    pid_item_nombre: "Actualización del Programa Institucional de Desarrollo de los Servicios de Salud de Hidalgo 2020-2022",
    pid_item_url: "/contenido/informacion/publicaciones/3. ACTUALIZACION_PID_SSH_2020-2022.pdf",
    pid_item_titulo: ""
  }
];
